<div class="dialogWrapper" [ngClass]="data.type">
    <header>
        <i class="fa fa-warning"></i>
        <h2>{{ 'generalKeywords.sessionInactivityModal.title' | translate }}</h2>
    </header>
    <div class="text-body">
        {{
            'generalKeywords.sessionInactivityModal.body'
                | translate
                    : {
                          minutes: minutes ? minutes + ' ' + minutesText : '',
                          seconds: seconds ? ' ' + seconds + ' ' + secondsText : '',
                      }
        }}
    </div>
    <footer>
        <button class="button" (click)="close(true)">{{ 'generalKeywords.sessionInactivityModal.logout' | translate }}</button>
        <button class="button primary" (click)="close(false)">{{ 'generalKeywords.sessionInactivityModal.stay' | translate }}</button>
    </footer>
</div>
